import React from 'react';
import { Lightbulb } from 'lucide-react';

interface KeyInsightsCardProps {
  insights: string[];
}

export function KeyInsightsCard({ insights }: KeyInsightsCardProps) {
  if (!insights.length) return null;

  return (
    <div
      className="mt-3 rounded-lg overflow-hidden border"
      style={{ backgroundColor: '#f7f3ee', borderColor: '#e5ddd4' }}
      data-testid="key-insights-card"
    >
      <div
        className="flex items-center gap-1.5 px-3 py-1.5 border-b"
        style={{ backgroundColor: '#efe8df', borderColor: '#e5ddd4' }}
      >
        <Lightbulb className="h-3.5 w-3.5" style={{ color: '#b8860b' }} />
        <span className="text-xs font-semibold" style={{ color: '#6b5c4c' }}>Key Insights</span>
      </div>
      <ul className="px-3 py-2 space-y-1.5">
        {insights.map((insight, idx) => (
          <li key={idx} className="flex gap-2 text-sm leading-snug" style={{ color: '#4a4238' }}>
            <span
              className="shrink-0 mt-0.5 h-4 w-4 rounded-full text-[10px] font-bold flex items-center justify-center"
              style={{ backgroundColor: '#e5ddd4', color: '#8b6914' }}
            >
              {idx + 1}
            </span>
            <span>{insight}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
